<template>

  <div style="position: absolute;z-index: 1;" title="Configurações Gerais">
    <b-dropdown title="Configurações" id="menu" size="lg" ref="dropdown" variant="link"
      toggle-class="text-decoration-none btnConfig"
      style="width: 29px; height: 32px; position: fixed; z-index: 11; right: 10px; top: 12px;display: inline-flex !important; background: #fff; border-radius: 4px; box-shadow: 0 0 0 2px rgba(0, 0, 0, .1) !important;"
      no-caret>
      <template #button-content>
        <svg id="svg-menu" title="Configurações" width="20" height="20" viewBox="0 0 20 20" fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="position: absolute; left: 17.5%; right: 12.5%; top: 30.5%; bottom: 12.5%;top: 6px !important;">
          <path
            d="M8.60417 3.5975C8.95917 2.13417 11.0408 2.13417 11.3958 3.5975C11.4491 3.81733 11.5535 4.02148 11.7006 4.19333C11.8477 4.36518 12.0332 4.49988 12.2422 4.58645C12.4512 4.67303 12.6776 4.70904 12.9032 4.69156C13.1287 4.67407 13.3469 4.60359 13.54 4.48583C14.8258 3.7025 16.2983 5.17417 15.515 6.46083C15.3974 6.65388 15.327 6.87195 15.3096 7.09731C15.2922 7.32267 15.3281 7.54897 15.4146 7.75782C15.5011 7.96666 15.6356 8.15215 15.8073 8.29921C15.9789 8.44627 16.1829 8.55075 16.4025 8.60417C17.8658 8.95917 17.8658 11.0408 16.4025 11.3958C16.1827 11.4491 15.9785 11.5535 15.8067 11.7006C15.6348 11.8477 15.5001 12.0332 15.4135 12.2422C15.327 12.4512 15.291 12.6776 15.3084 12.9032C15.3259 13.1287 15.3964 13.3469 15.5142 13.54C16.2975 14.8258 14.8258 16.2983 13.5392 15.515C13.3461 15.3974 13.1281 15.327 12.9027 15.3096C12.6773 15.2922 12.451 15.3281 12.2422 15.4146C12.0333 15.5011 11.8479 15.6356 11.7008 15.8073C11.5537 15.9789 11.4492 16.1829 11.3958 16.4025C11.0408 17.8658 8.95917 17.8658 8.60417 16.4025C8.5509 16.1827 8.44648 15.9785 8.29941 15.8067C8.15233 15.6348 7.96676 15.5001 7.75779 15.4135C7.54882 15.327 7.32236 15.291 7.09685 15.3084C6.87133 15.3259 6.65313 15.3964 6.46 15.5142C5.17417 16.2975 3.70167 14.8258 4.485 13.5392C4.60258 13.3461 4.67296 13.1281 4.6904 12.9027C4.70785 12.6773 4.67187 12.451 4.58539 12.2422C4.49892 12.0333 4.36438 11.8479 4.19273 11.7008C4.02107 11.5537 3.81714 11.4492 3.5975 11.3958C2.13417 11.0408 2.13417 8.95917 3.5975 8.60417C3.81733 8.5509 4.02148 8.44648 4.19333 8.29941C4.36518 8.15233 4.49988 7.96676 4.58645 7.75779C4.67303 7.54882 4.70904 7.32236 4.69156 7.09685C4.67407 6.87133 4.60359 6.65313 4.48583 6.46C3.7025 5.17417 5.17417 3.70167 6.46083 4.485C7.29083 4.99167 8.37417 4.54333 8.60417 3.5975Z"
            stroke="#6A707C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 10C7.5 9.33696 7.76339 8.70107 8.23223 8.23223C8.70107 7.76339 9.33696 7.5 10 7.5C10.663 7.5 11.2989 7.76339 11.7678 8.23223C12.2366 8.70107 12.5 9.33696 12.5 10V10Z"
            stroke="#6A707C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </template>
      <!-- <b-dd-item @click="OpenDataLeadManager()">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 3.375V9.625C1.5 11.0063 3.73875 12.125 6.5 12.125C9.26125 12.125 11.5 11.0063 11.5 9.625V3.375M1.5 3.375C1.5 4.75625 3.73875 5.875 6.5 5.875C9.26125 5.875 11.5 4.75625 11.5 3.375M1.5 3.375C1.5 1.99375 3.73875 0.875 6.5 0.875C9.26125 0.875 11.5 1.99375 11.5 3.375M11.5 6.5C11.5 7.88125 9.26125 9 6.5 9C3.73875 9 1.5 7.88125 1.5 6.5" stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> &nbsp; Consumo
          </b-dd-item> -->
      <b-dd-item @click="OpenColumnChooser()" v-if="false">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.5 2.125C1.5 1.95924 1.56585 1.80027 1.68306 1.68306C1.80027 1.56585 1.95924 1.5 2.125 1.5H10.875C11.0408 1.5 11.1997 1.56585 11.3169 1.68306C11.4342 1.80027 11.5 1.95924 11.5 2.125V3.375C11.5 3.54076 11.4342 3.69973 11.3169 3.81694C11.1997 3.93415 11.0408 4 10.875 4H2.125C1.95924 4 1.80027 3.93415 1.68306 3.81694C1.56585 3.69973 1.5 3.54076 1.5 3.375V2.125ZM1.5 7.125C1.5 6.95924 1.56585 6.80027 1.68306 6.68306C1.80027 6.56585 1.95924 6.5 2.125 6.5H5.875C6.04076 6.5 6.19973 6.56585 6.31694 6.68306C6.43415 6.80027 6.5 6.95924 6.5 7.125V10.875C6.5 11.0408 6.43415 11.1997 6.31694 11.3169C6.19973 11.4342 6.04076 11.5 5.875 11.5H2.125C1.95924 11.5 1.80027 11.4342 1.68306 11.3169C1.56585 11.1997 1.5 11.0408 1.5 10.875V7.125ZM9 7.125C9 6.95924 9.06585 6.80027 9.18306 6.68306C9.30027 6.56585 9.45924 6.5 9.625 6.5H10.875C11.0408 6.5 11.1997 6.56585 11.3169 6.68306C11.4342 6.80027 11.5 6.95924 11.5 7.125V10.875C11.5 11.0408 11.4342 11.1997 11.3169 11.3169C11.1997 11.4342 11.0408 11.5 10.875 11.5H9.625C9.45924 11.5 9.30027 11.4342 9.18306 11.3169C9.06585 11.1997 9 11.0408 9 10.875V7.125Z"
            stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg> &nbsp; Templates de Colunas
      </b-dd-item>

      <b-dd-item @click=" OpenConfigStatus()">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.5 9.625C1.5 10.1223 1.69754 10.5992 2.04917 10.9508C2.40081 11.3025 2.87772 11.5 3.375 11.5H9.625C10.1223 11.5 10.5992 11.3025 10.9508 10.9508C11.3025 10.5992 11.5 10.1223 11.5 9.625M9 4L6.5 1.5M6.5 1.5L4 4M6.5 1.5V9"
            stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg> &nbsp; Status Upload
      </b-dd-item>
      <b-dd-item @click=" OpenAdmin()">
        <svg width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.125 1.375L7.125 6.375L4.625 3.875L0.875 7.625M7.125 1.375H12.125H7.125ZM12.125 1.375V6.375V1.375Z"
            stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>&nbsp; Administração
      </b-dd-item>

      <b-dropdown-form style="margin-top:5px;margin-bottom: 5px;">
        <svg style="margin-left: 20px;" width="13" height="13" viewBox="0 0 13 13" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.5 2.125C1.5 1.95924 1.56585 1.80027 1.68306 1.68306C1.80027 1.56585 1.95924 1.5 2.125 1.5H10.875C11.0408 1.5 11.1997 1.56585 11.3169 1.68306C11.4342 1.80027 11.5 1.95924 11.5 2.125V3.375C11.5 3.54076 11.4342 3.69973 11.3169 3.81694C11.1997 3.93415 11.0408 4 10.875 4H2.125C1.95924 4 1.80027 3.93415 1.68306 3.81694C1.56585 3.69973 1.5 3.54076 1.5 3.375V2.125ZM1.5 7.125C1.5 6.95924 1.56585 6.80027 1.68306 6.68306C1.80027 6.56585 1.95924 6.5 2.125 6.5H5.875C6.04076 6.5 6.19973 6.56585 6.31694 6.68306C6.43415 6.80027 6.5 6.95924 6.5 7.125V10.875C6.5 11.0408 6.43415 11.1997 6.31694 11.3169C6.19973 11.4342 6.04076 11.5 5.875 11.5H2.125C1.95924 11.5 1.80027 11.4342 1.68306 11.3169C1.56585 11.1997 1.5 11.0408 1.5 10.875V7.125ZM9 7.125C9 6.95924 9.06585 6.80027 9.18306 6.68306C9.30027 6.56585 9.45924 6.5 9.625 6.5H10.875C11.0408 6.5 11.1997 6.56585 11.3169 6.68306C11.4342 6.80027 11.5 6.95924 11.5 7.125V10.875C11.5 11.0408 11.4342 11.1997 11.3169 11.3169C11.1997 11.4342 11.0408 11.5 10.875 11.5H9.625C9.45924 11.5 9.30027 11.4342 9.18306 11.3169C9.06585 11.1997 9 11.0408 9 10.875V7.125Z"
            stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg> &nbsp; Tema
        <svg style="margin-left:10px;margin-top: -3px;" width="14" height="14" viewBox="0 0 14 14" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13 9.09589C11.8678 9.55102 10.6267 9.66349 9.43101 9.41931C8.23535 9.17513 7.13784 8.58507 6.27492 7.72248C5.41199 6.85989 4.8217 5.76281 4.57743 4.56761C4.33315 3.37241 4.44567 2.1318 4.90098 1C3.56016 1.53986 2.44897 2.52914 1.75789 3.79824C1.0668 5.06734 0.83887 6.53722 1.11316 7.9559C1.38746 9.37459 2.1469 10.6537 3.26129 11.574C4.37568 12.4943 5.77562 12.9984 7.22111 13C8.46413 13 9.67873 12.6283 10.7086 11.9325C11.7385 11.2367 12.5365 10.2488 13 9.09589Z"
            stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg> <toggle-button color="#23A6F0" v-model="darkmode"
          style="z-index:999999;margin: -2px 2px 0px 2px; margin-left: 5px;" />
        <svg style="margin-top: -3px;" width="14" height="14" viewBox="0 0 14 14" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 1V1.66667V1ZM7 12.3333V13V12.3333ZM13 7H12.3333H13ZM1.66667 7H1H1.66667ZM11.2427 11.2427L10.7713 10.7713L11.2427 11.2427ZM3.22867 3.22867L2.75733 2.75733L3.22867 3.22867ZM11.2427 2.75733L10.7713 3.22867L11.2427 2.75733ZM3.22867 10.7713L2.75733 11.2427L3.22867 10.7713ZM9.66667 7C9.66667 7.70724 9.38572 8.38552 8.88562 8.88562C8.38552 9.38572 7.70724 9.66667 7 9.66667C6.29276 9.66667 5.61448 9.38572 5.11438 8.88562C4.61428 8.38552 4.33333 7.70724 4.33333 7C4.33333 6.29276 4.61428 5.61448 5.11438 5.11438C5.61448 4.61428 6.29276 4.33333 7 4.33333C7.70724 4.33333 8.38552 4.61428 8.88562 5.11438C9.38572 5.61448 9.66667 6.29276 9.66667 7V7Z"
            stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

      </b-dropdown-form>

      <b-dd-item @click="LogOff()">
        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.125 9V9.625C7.125 10.1223 6.92746 10.5992 6.57583 10.9508C6.22419 11.3025 5.74728 11.5 5.25 11.5H2.75C2.25272 11.5 1.77581 11.3025 1.42417 10.9508C1.07254 10.5992 0.875 10.1223 0.875 9.625V3.375C0.875 2.87772 1.07254 2.40081 1.42417 2.04917C1.77581 1.69754 2.25272 1.5 2.75 1.5H5.25C5.74728 1.5 6.22419 1.69754 6.57583 2.04917C6.92746 2.40081 7.125 2.87772 7.125 3.375V4M9.625 9L12.125 6.5L9.625 9ZM12.125 6.5L9.625 4L12.125 6.5ZM12.125 6.5H3.375H12.125Z"
            stroke="#3C434D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>&nbsp; Sair
      </b-dd-item>

      <b-dropdown-item disabled :title="`Versão: ${version} | Build: ${buildDate}`">
        <small>{{ environment }}</small>
      </b-dropdown-item>
    </b-dropdown>

    <!-- SYNCFUSION SIDEBAR -->

    <!-- COGNATIS SIDEBAR -->
    <div style="overflow:hidden">

      <transition name="slide-fade">
        <div v-if="CogSlideModal"
          style="position: absolute;background:#f2f2f2;border: 1px solid;z-index: 100;top:45px;left:0;width: 350px; height:1900px ">
          <div style="margin-left:20px;margin-top:5px;margin-right:5px">
            <b-row style="height: 35px;padding-top: 5px">
              <b-col cols="4">
                <a class="" style="color:#818082" href="javascript:void(0)" @click="HideAndShowCogSlide">
                  <i class="fas fa-angle-double-left " />
                </a>
              </b-col>
              <b-col>
                <h5>Gerenciador de Camadas</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-list-group style="width: 97%">
                <b-list-group-item href="#" variant="light" @click="OpenBusinessFilter">

                  <div class="d-flex w-100 justify-content-between">
                    <h6 class="mb-1">Smartleads Business</h6>
                  </div>

                </b-list-group-item>
                <b-list-group-item href="#" variant="light" @click="OpenPeopleFilter">
                  <div class="d-flex w-100 justify-content-between">
                    <h6 class="mb-1">Smartleads People</h6>
                  </div>

                </b-list-group-item>
                <b-list-group-item href="#" variant="light">

                  <div class="d-flex w-100 justify-content-between">
                    <h6 class="mb-1">Geopop</h6>
                  </div>

                </b-list-group-item>
                <b-list-group-item href="#" variant="light">
                  <div class="d-flex w-100 justify-content-between">
                    <b-btn-group style="width: 100%">
                      <b-btn variant="outline-info"
                        v-b-popover.hover.bottom="{ customClass: 'tooltip-class', content: 'Nova Tabela' }"
                        @click="OpenUpload()" style="width: 100%">
                        Nova Tabela / Upload <i class="fas fa-plus"></i>
                      </b-btn>
                      <!--<b-dd :right="isRTL" text="" variant="info">-->
                      <!--<b-dd-item><strike>Opção Possivel 1</strike></b-dd-item>-->
                      <!--<b-dd-item><strike>Opção Possivel 2</strike></b-dd-item>-->
                      <!--</b-dd>-->
                    </b-btn-group>
                  </div>
                </b-list-group-item>

              </b-list-group>
            </b-row>
            <b-row>
              <LayerVisibility></LayerVisibility>
            </b-row>
          </div>
        </div>
      </transition>

      <transition name="slide-fade">
        <div v-if="CogSlideModalSecondary"
          style="position: absolute;background:#f2f2f2;border: 1px solid;z-index: 51;top:45px;left:350px; height:1900px "
          v-bind:style="{ width: sizeSecondaryModal + '%' }">
          <div style="margin-left:20px;margin-top:5px;margin-right:5px">
            <b-row style="height: 35px;padding-top: 5px">
              <b-col cols="4">

              </b-col>
              <b-col style="max-width: 100%;min-width: 100%">
                <UploadPage v-if="UploadModal" v-on:modalClose="modalClose"></UploadPage>
              </b-col>
            </b-row>
          </div>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>

import { SidebarPlugin } from '@syncfusion/ej2-vue-navigations'

import UploadPage from '../components/upload/UploadManager.vue'
import Vue from 'vue'
import { loadProgressBar } from 'axios-progress-bar'
import Services from '../components/http/request'
import messenger from '../components/messenger/messenger'
import io from 'socket.io-client'
import Notification from '../components/administration/NotificationManager.vue'
import ToggleButton from 'vue-js-toggle-button'
import Intercom from '@intercom/messenger-js-sdk';

Vue.use(ToggleButton)

export default {
  name: 'app-layout-navbar',
  components: {
    UploadPage,

    SidebarPlugin,
    Notification
  },
  props: {
    sidenavToggle: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    version: '',
    buildDate: '',
    environment: '',
    darkmode: false,
    countMessages: 0,
    labelNavFixed: false,
    sidebarFixed: false,
    CogSlideModal: false,
    CogSlideModalSecondary: false,
    UploadModal: false,
    Username: Vue.prototype.$foundation.getCurrentUser(),
    sizeSecondaryModal: 60,
    showBusinessFilter: true,
    notifications: []
  }),
  methods: {
    mudarTema() {
      if (this.darkmode == false) { this.darkmode = true } else { this.darkmode = false }
    },
    checkPanelMode(notifications) {
      if (!Array.isArray(notifications)) return false
      let self = this
      notifications.forEach(function (notification, index) {
        if (!notification.hasOwnProperty('jbAction')) {
          console.warn("Notificação não possui propriedade 'jbAction'")
          return
        }
        if (!Array.isArray(notification.jbAction)) {
          console.warn("Esperado um array para a propriedade 'jbAction'")
          return
        }
        notification.jbAction.forEach(function (action) {
          if (action.actionType === 'SimpleConfirmation' &&
            (action.method === 'NewItemOnToc' || action.method === 'ShowPurchase')) {
            self.$refs.notificationArea.show()
          }
        })
      })
    },
    CheckMessages() {
      // console.log("Request Notificações")
      let request = new Services({ tag: 'das' })
      let environmentId = Vue.prototype.$foundation.getEnvironmentId()
      let userId = Vue.prototype.$foundation.getTokenClaims()['UserId']
      let baseUri = `/api/0.1-a/Messenger/GetNewMessages/${environmentId}/${userId}`
      request.get(baseUri, {}, (response) => {
        let notifications = response.data
        this.checkPanelMode(notifications)
      }, (error) => {
        console.log(error)
      })
    },
    /* addNotification(message) {
        this.notifications.push(message)
        messenger.info({position: 'top-end', title: message.message});
      }, */
    toggleNotificationPanel(status) {
      if (status) { this.$refs.notificationArea.show() } else { this.$refs.notificationArea.hide() }
    },
    sidebarToggle() {
      this.sidebarFixed = !this.sidebarFixed
      const wrapperGlobal = document.querySelector('.layout-global-container')
      const navBarHeader = document.querySelector('.navbar-header')
      const sideBarNav = document.querySelector('.sidebar-nav')

      if (this.sidebarFixed == true) {
        wrapperGlobal.classList.add('fixed')
        navBarHeader.classList.add('fixed')
        sideBarNav.classList.add('fixed')
      } else {
        wrapperGlobal.classList.remove('fixed')
        navBarHeader.classList.remove('fixed')
        sideBarNav.classList.remove('fixed')
      }
    },
    OpenConfigStatus() {
      this.$router.push('/configstatus')
    },
    OpenColumnChooser() {
      this.$router.push('/columnchooser')
    },
    OpenAdmin() {
      this.$router.push('/admin')
    },
    OpenColumnChooserPurchase() {
      this.$router.push('/columnchooserpurchase')
    },
    OpenUsersList() {
      this.$router.push('/Admin')
    },
    OpenDataLeadManager() {
      this.$router.push('/datalead')
    },
    LogOff() {
      // this.$emit('beforeExit')
      document.cookie = 'ssoSessionKey=; Max-Age=-99999999; path=/';
      sessionStorage.clear()
      localStorage.clear()
      this.$session.destroy()
      window.location.href = 'https://cognatis.com.br/';
      // this.$router.push('/')
    },
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed()
    },
    getLayoutNavbarBg() {
      return this.layoutNavbarBg
    },
    showSlideModal() {
      // this.$refs.slideModal.show()
      this.$bus.$emit('ShowAndHideToc')
    },
    HideAndShowCogSlide() {
      console.log('OPEN')
      // this.CogSlideModal = !this.CogSlideModal
      this.CogSlideModalSecondary = false
      this.$bus.$emit('ShowAndHideToc')
      this.UploadModal = false
      this.sizeSecondaryModal = 60
      this.showBusinessFilter = false
      this.$bus.$emit('ShowBusinessFtr', this.showBusinessFilter)
    },
    OpenBusinessFilter() {
      this.showBusinessFilter = !this.showBusinessFilter
      this.$bus.$emit('ShowBusinessFtr', this.showBusinessFilter)
    },
    OpenPeopleFilter() {
      this.CogSlideModalSecondary = !this.CogSlideModalSecondary
    },
    OpenUpload() {
      this.CogSlideModalSecondary = !this.CogSlideModalSecondary
      this.UploadModal = !this.UploadModal
      this.showBusinessFilter = false
      this.sizeSecondaryModal = 45
    },
    modalClose() {
      this.HideAndShowCogSlide()
    },
    handleEvents: function () {
      /* this.$bus.$on('addNotification', (message) => {
          this.addNotification(message)
        }) */
      this.$bus.$on('updateMessages', (messages) => {
        this.countMessages = messages.length
        this.checkPanelMode(messages)
      })
      this.$bus.$on('onShowPurchase', (options) => {
        // console.log(options);
        this.$refs.notificationArea.hide()
        this.$router.push('/datalead')
      })
    },
    handleMessages: function () {
      try {
        // let user = Vue.prototype.$foundation.getTokenClaims()['cUser']
        // let domain = Vue.prototype.$foundation.getTokenClaims()['cClient']
        let request = new Services({ tag: 'messenger' })
        let endPoint = `${request.getServiceEndPoint({})}`
        let socket = io(endPoint)
        // const self = this

        socket.on('file.import.succeeded', this.onFileImportSucceeded)

        // Listener de mensagens (front-end, back-end e outros usuários)
        // Movido para o componente NotificationManager.vue (Ferraz)
        /* socket.on('onNotify', function (data) {
            console.log("Notify")
            console.log(JSON.stringify(data));
            self.CheckMessages()
          }); */

        // Listener de mensagens para login privado
        /*
        socket.on('onLogin', function (input) {
          if (!input) return
          if (input.hasOwnProperty('token')) {
            Vue.prototype.$foundation.setMessengerId(input.token)
          }
        })

        // Listener de mensagens para login do domínio/sala
        socket.on('onConnected', function (data) {
          console.log(JSON.stringify(data))
        })

        // Listener de mensagens para logoff do domínio/sala
        socket.on('onDisconnected', function (data) {
          console.log(JSON.stringify(data))
        })

        // Listener de mensagens para alterações na sala
        socket.on('onRoomChanged', function (data) {
          console.log(JSON.stringify(data))
        })

        socket.emit('join', user, domain)
        */
      } catch (e) {
        console.log(e)
      }
    },
    onFileImportSucceeded(e) {
      // const self = this
      const userEmail = Vue.prototype.$foundation.getCurrentUser()
      if (e.Email === userEmail) {
        const message = `Arquivo importado com sucesso.`
        messenger.warn({ position: 'center', title: message })
      }
    },
    onOver() {
      // alert('Funciona')
      this.$refs.dropdown.visible = true
      this.configure = false
    },
    onLeave() {
      // this.$refs.dropdownConfig.visible = false
      this.configure = true
    }
  },
  computed: {
    curClasses() {
      let bg = this.layoutSidenavBg

      if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
        bg = bg
          .replace(' sidenav-dark', '')
          .replace(' sidenav-light', '')
          .replace('-darker', '')
          .replace('-dark', '')
      }
      return `bg-${bg} `
    },
    titleLabelNav() {
      const navFixed = this.sidebarFixed

      if (navFixed == true) {
        return 'Desfixar Menu Lateral'
      } else {
        return 'Fixar Menu Lateral'
      }
    }
  },
  created() {

    console.log('LayoutNavbar.vue - created')
    this.version = process.env.VUE_APP_GIT_VERSION;
    this.buildDate = process.env.VUE_APP_BUILD_DATE;
    this.environment = process.env.NODE_ENV;
    switch (this.environment) {
      case 'development':
        this.environment = `DEV - ${this.version.substring(0, 23)}`;
        break;
      case 'production':
        this.environment = `PRD - ${this.version.substring(0, 23)}`;
        break;
      case 'homologation':
        this.environment = `HML - ${this.version.substring(0, 23)}`;
        break;
      default:
        this.environment = '';
    }
    console.log(`Versão: ${this.version} | Build: ${this.buildDate}`);


    let progressBarCfg = { parent: '#pnlGrid' }
    // loadProgressBar();
    this.handleEvents()
    this.handleMessages();
    // console.warn('Serviço de Mensageria -Desligado temporariamente')
  },
  mounted() {
    const sUser = Vue.prototype.$foundation.getTokenClaims()
    this.CheckMessages()
    Intercom({
      app_id: 'a2lxdapo',
      user_id: sUser.UserId, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
      name: sUser.name, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
      email: sUser.cUser, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
      created_at: sUser.exp, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
      language_override: "pt-BR" // Define o idioma para português do Brasil
    });
  },
  watch: {
    darkmode: function (val) {
      if (val) {
        /* ADICIONANDO TODAS AS CLASSES PARA O DARK MODE */
        document.getElementById('sidebar-nav').classList.add('sidebar-darkmode')
        document.body.classList.add('darkmode')
      } else {
        /* REMOVENDO TODAS AS CLASSES PARA O DARK MODE */
        document.getElementById('sidebar-nav').classList.toggle('sidebar-darkmode')
        document.body.classList.toggle('darkmode')
      }
    }
  }
}
</script>
<style>
@import '../../node_modules/axios-progress-bar/dist/nprogress.css';

#nprogress {
  transition: all .3s linear;
  background: rgba(255, 255, 255, .3);
  position: fixed;
  top: 0;
  z-index: 1001;
  width: 100%;
  height: 100%;
}

#nprogress .bar {
  background: #F58026 !important;
}

#nprogress .peg {
  box-shadow: 0 0 10px #F58026, 0 0 5px #F58026 !important;
}

#nprogress .spinner-icon {
  position: absolute;
  right: 50%;
  top: 50%;
  width: 75px;
  height: 75px;
  border-top-color: #F58026 !important;
  border-left-color: #F58026 !important;
  border-width: 5px;
  z-index: 1001 !important;
}

.slide-fade-enter-active {
  transition: all .9s ease
}

.slide-fade-enter {
  transform: translateX(10px)
}

.slide-fade-leave-active {
  transition: all .9s ease;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active em versões anteriores a 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.geocoder {
  position: absolute !important;
  z-index: 1;
  width: 400px;
  margin-left: 0.5rem !important;
  right: 26px;
  top: 10px;
  transition: 0.5s;
}

.mapboxgl-ctrl-geocoder {
  min-width: 100%;
}

.dropdown>ul {
  background: #FFFFFF;
  box-shadow: 0px 2.33503px 2.33503px #C4C4C4;
  border-radius: 8.63959px 8.63959px 8.63416px 8.63416px;
}

.config {
  position: absolute !important;
  width: 29px !important;
  height: 30px !important;
  right: 10px !important;
  top: 12px !important;
  background: #FBFCFD;
  box-shadow: 0px 1px 2px rgb(0 0 0 / 25%) !important;
  border-radius: 5px !important;
  z-index: 6 !important;
}
</style>
